import React from 'react'

// import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

// import { Icon } from '../Icon'

interface Props {
  title: string
  placeholderText?: string
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  value?: string
  readOnly?: boolean
}

const UIDatePickerv: React.FC<Props> = ({
  title,
  placeholderText,
  onChange,
  value,
  readOnly,
}) => {
  // const [isOpen, setIsOpen] = useState<boolean>(false)

  return (
    <div className="relative">
      <label className="text-xs font-medium text-text1">{title}</label>
      <div className="w-[100%] mt-2 h-[48px] p-3 border rounded-xl flex  gap-2 justify-between items-center border-gray3">
        {/* <DatePicker
          className="border-none bg-transparent outline-none cursor-pointer text-sm font-normal text-text4 placeholder:text-text3"
          selected={date}
          onChange={(date: Date | null) => setDate(date)}
          placeholderText={placeholderText}
          open={isOpen}
          onSelect={() => setIsOpen(!isOpen)}
        /> */}
        <input
          className={`w-[100%] border-none bg-transparent outline-none cursor-pointer text-sm font-normal ${value == '' ? 'font-normal' : value == undefined ? 'font-normal' : 'font-semibold'} ${value == '' ? 'text-text3' : 'text-text4'} text-text4 placeholder:text-text3`}
          type={'date'}
          onChange={onChange}
          // value={value}
          defaultValue={value}
          placeholder={placeholderText}
          readOnly={readOnly}
          min={2000}
          // min={2000}
        />
        {/* <span onClick={() => setIsOpen(!isOpen)}>
          <Icon
            name={'IconCalander'}
            width={16}
            height={16}
            strokeWidth={1}
            stroke="#02698C"
          />
        </span> */}
      </div>
    </div>
  )
}

export default UIDatePickerv
